import { render, staticRenderFns } from "./CrewMemberInfo.vue?vue&type=template&id=1745a0a2&scoped=true&"
import script from "./CrewMemberInfo.vue?vue&type=script&lang=js&"
export * from "./CrewMemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./CrewMemberInfo.vue?vue&type=style&index=0&id=1745a0a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745a0a2",
  null
  
)

export default component.exports